var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v("Register")]),_c('p',[_vm._v("Create a new account in finemenu")]),_c('sign-up1-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }